import { TemplateTypes } from '../../../../../../../../../lib/models/TemplateTypes';

export const filterElements = items => items.filter(item => item.templateType !== TemplateTypes.PAGE);

export const checkElement = (items, elementId) => items.some(element => element.id === elementId);

export const getElementObject = (items, elementId) => items.find(element => element.id === elementId);
